import { useMutation } from '@tanstack/vue-query'
import { hcaClientFactory } from '@/api/factories/HcaClientFactory'

export const useDownloadImagesZipMutation = () => {
    return useMutation({
        mutationFn: async (payload: { filePaths: Array<string>}) =>
            (await hcaClientFactory.imagesApi.downloadImagesZip({ filePaths: payload.filePaths }, {responseType: 'blob'})).data as unknown as Blob,
    })
}
